<h1 mat-dialog-title>Assigned task</h1>

<div mat-dialog-content class="rnr">
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

    <div class="rnr__alert" *ngIf="loadError">
        <mat-icon>error_outline</mat-icon>
        <div>{{ loadError }}</div>
    </div>

    <ng-container *ngIf="task">
        <div class="rnr__author" data-test="task">
            <mat-icon>task_alt</mat-icon>
            <div>
                <div class="rnr__author-name">{{ task.task }}</div>
                <div class="hint">
                    {{ data.patientName || 'Patient' }}<span *ngIf="task.dueDate"> · Due {{ task.dueDate | date: 'd MMM y' }}</span>
                </div>
                <div class="hint">Assigned to: {{ assigneeSummary(task) }}</div>
            </div>
        </div>
        <p *ngIf="task.notes" style="white-space: pre-line">{{ task.notes }}</p>
        <div class="rnr__status" *ngIf="task.status !== 'Pending'">
            <mat-icon>check_circle</mat-icon>
            <div>This task is {{ task.status | lowercase }}.</div>
        </div>
        <div class="rnr__alert" *ngIf="actionError">
            <mat-icon>error_outline</mat-icon>
            <div>{{ actionError }}</div>
        </div>
    </ng-container>
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="close()" [disabled]="isSaving">Close</button>
    <button mat-flat-button color="primary" *ngIf="task && task.status === 'Pending'" (click)="complete()"
        [disabled]="isSaving" data-test="complete">
        {{ isSaving ? 'Saving…' : 'Mark complete' }}
    </button>
</div>
